import React from 'react';
import '../CSS/QuemsomosAboutus.css';
import backgroundImage from '../Images/fundo2.png';
import backgroundImageWebp from '../Images/fundo2.webp';

const Terms = () => {
  return (
    <div>
      <picture>
        <source srcSet={backgroundImageWebp} type="image/webp" />
        <img src={backgroundImage} className="backImage2" alt="" loading="eager" decoding="async" />
      </picture>

      <div className="er-pageShell">
        <div className="divCenteredContent er-container">
          <div className="divBigTitle">
            <h1 className="BigTitle">Terms and Conditions</h1>
          </div>

          <p className="regularText">
            These Terms and Conditions govern the use of this website and the services provided by the escape room business,
            based in Portugal.
          </p>
          <p className="regularText">
            By using the website, making a reservation, or purchasing a voucher, the user agrees to these Terms and Conditions.
          </p>

          <p className="regularTextYellow">1. Identification</p>
          <p className="regularText">
            These Terms and Conditions govern the use of this website and the services provided by the escape room business,
            based in Portugal.
          </p>

          <p className="regularTextYellow">2. Services</p>
          <p className="regularText">
            The escape room provides on-site escape game experiences, subject to prior reservation, as well as the sale of vouchers
            through the website.
          </p>

          <p className="regularTextYellow">3. Reservations</p>
          <p className="regularText">Reservations are subject to room and time availability.</p>
          <p className="regularText">
            The customer is responsible for providing accurate and complete information when making a reservation.
          </p>
          <p className="regularText">
            The escape room reserves the right to cancel or modify reservations due to force majeure or operational reasons, with prior
            notice whenever possible.
          </p>

          <p className="regularTextYellow">4. Vouchers and Online Payments</p>
          <p className="regularText">Online payments are available exclusively for the purchase of vouchers.</p>
          <p className="regularText">Payments are processed through secure third-party payment platforms.</p>
          <p className="regularText">The escape room does not store payment card details.</p>
          <p className="regularText">
            Vouchers are valid for the period indicated at the time of purchase and are non-refundable, except where required by law.
          </p>

          <p className="regularTextYellow">5. Cancellations and No-Shows</p>
          <p className="regularText">
            Cancellation or rescheduling conditions may vary and will be communicated at the time of booking.
          </p>
          <p className="regularText">
            Failure to attend at the scheduled time may result in the loss of the reservation or voucher, without any right to refund.
          </p>

          <p className="regularTextYellow">6. Participation Rules</p>
          <p className="regularText">Participants must follow the instructions provided by the staff.</p>
          <p className="regularText">Any damage to equipment or scenarios is strictly prohibited.</p>
          <p className="regularText">
            The escape room is not responsible for lost, stolen, or damaged personal belongings.
          </p>

          <p className="regularTextYellow">7. Monitoring Cameras</p>
          <p className="regularText">
            The escape room facilities are equipped with monitoring cameras used exclusively for real-time supervision during the game,
            for safety and operational purposes.
          </p>
          <p className="regularText">No image or audio recording is carried out.</p>

          <p className="regularTextYellow">8. Liability</p>
          <p className="regularText">
            The escape room shall not be held liable for damages resulting from improper use of the facilities or failure to comply with
            the rules by participants.
          </p>

          <p className="regularTextYellow">9. Data Protection</p>
          <p className="regularText">
            The processing of personal data is governed by the Privacy Policy available on the website, which forms an integral part of
            these Terms and Conditions.
          </p>

          <p className="regularTextYellow">10. Changes to the Terms</p>
          <p className="regularText">
            The escape room reserves the right to update or modify these Terms and Conditions at any time.
          </p>
          <p className="regularText">Any changes will be published on the website.</p>

          <p className="regularTextYellow">11. Applicable Law and Jurisdiction</p>
          <p className="regularText">These Terms and Conditions are governed by Portuguese law.</p>
          <p className="regularText">
            In the event of a dispute, the competent courts of Portugal shall have jurisdiction, unless otherwise required by law.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;

